import { styled, css } from '@mui/material';

const BaseStyles = theme => css`
  padding: ${theme.spacing(0.25, 1)};
  line-height: 1.3;

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;
const GrayVariant = theme => css`
  background-color: ${theme.palette.gray60};
  color: ${theme.palette.white};
`;
const LightGrayVariant = theme => css`
  background-color: ${theme.palette.gray40};
  color: ${theme.palette.gray70};
`;
const GreenVariant = theme => css`
  background-color: ${theme.palette.greenBase};
  color: ${theme.palette.white};
`;
const LightGreenVariant = theme => css`
  background-color: ${theme.palette.green30};
  color: ${theme.palette.green70};
`;
const OrangeVariant = theme => css`
  background-color: ${theme.palette.orangeBase};
  color: ${theme.palette.white};
`;
const LightOrangeVariant = theme => css`
  background-color: ${theme.palette.orange30};
  color: ${theme.palette.orange70};
`;
const RedVariant = theme => css`
  background-color: ${theme.palette.redBase};
  color: ${theme.palette.white};
`;
const LightRedVariant = theme => css`
  background-color: ${theme.palette.red30};
  color: ${theme.palette.red70};
`;
const BlueVariant = theme => css`
  background-color: ${theme.palette.blueBase};
  color: ${theme.palette.white};
`;
const LightBlueVariant = theme => css`
  background-color: ${theme.palette.blue30};
  color: ${theme.palette.blue70};
`;
const BlackVariant = theme => css`
  background-color: ${theme.palette.blue80};
  color: ${theme.palette.white};
`;
const SmSize = _theme => css`
  padding: 1px 4px;
`;
const TagContainer = styled('span')(_ref => {
  let {
    theme,
    variant,
    size
  } = _ref;
  return [theme.typography.caption, BaseStyles(theme), variant === 'gray' && GrayVariant(theme), variant === 'light-gray' && LightGrayVariant(theme), variant === 'green' && GreenVariant(theme), variant === 'light-green' && LightGreenVariant(theme), variant === 'orange' && OrangeVariant(theme), variant === 'light-orange' && LightOrangeVariant(theme), variant === 'red' && RedVariant(theme), variant === 'light-red' && LightRedVariant(theme), variant === 'blue' && BlueVariant(theme), variant === 'light-blue' && LightBlueVariant(theme), variant === 'black' && BlackVariant(theme), size === 'compact' && SmSize()];
});

export { TagContainer };
